<template>
  <CCardBody>
    <CDataTable class="custom-pagination" :items="ticketsData" :fields="tableFields" table-filter items-per-page-select
      :items-per-page="5" hover pagination>
      
      <template #ticketNumber="{ item }">
        <td>
          <div class="font-weight-bold text-primary">{{ item.ticketNumber || '-' }}</div>
        </td>
      </template>

      <template #reported_datetime="{ item }">
        <td>
          <div>{{ formatDate(item.userPart.dateTimeInformed) }}</div>
        </td>
      </template>

      <template #issue_user="{ item }">
        <td>
          <div>
            <span class="font-weight-bold">{{ getCategoryName(item) }}</span> | {{ getSubCategoryName(item) }}
            <div v-if="item.userPart && item.userPart.onBehalfOf" class="small text-danger mt-1">
              ({{ $t('table.user.onBehalf') }} {{ item.userPart.onBehalfOf }})
            </div>
          </div>
        </td>
      </template>

      <template #status="{ item }">
        <td class="text-center">
          <span class="status-circle" :style="{ backgroundColor: getBadge(item.status) }"
            :title="getStatusText(item.status)"></span>
        </td>
      </template>

      <template #show_details="{ item }">
        <td class="text-center">
          <button v-if="item.status === 'done'" class="circle-success-btn" @click="showDetail(item, true)">
            <CIcon name="cil-window-restore" size="xl" />
          </button>

          <div v-else class="d-flex justify-content-center align-items-center" style="gap: 5px;">
            <button class="circle-action-btn" :title="$t('table.user.btn.track')" @click="showDetail(item, false)">
              <CIcon name="cil-window-restore" size="xl" />
            </button>
            <button v-if="item.status === 'pending'" class="circle-cancel-btn" :title="$t('table.user.btn.cancelRequest')" @click="cancelTicket(item)">
              <CIcon name="cil-trash" size="xl" />
            </button>
          </div>
        </td>
      </template>

    </CDataTable>
    <div class="status-legend mt-3">
      <div class="legend-item">
        <span class="status-circle" style="background:#e55353"></span>
        <span>{{ $t('table.user.legend1') }}</span>
      </div>
      <div class="legend-item">
        <span class="status-circle" style="background:#fd7e14"></span>
        <span>{{ $t('table.user.legend2') }}</span>
      </div>
      <div class="legend-item">
        <span class="status-circle" style="background:#ffeb3b"></span>
        <span>{{ $t('table.user.legend3') }}</span>
      </div>
      <div class="legend-item">
        <span class="status-circle" style="background:#2eb85c"></span>
        <span>{{ $t('table.user.legend4') }}</span>
      </div>
    </div>

  </CCardBody>
</template>

<style>
/* CSS เดิมของคุณ (ไม่มีการเปลี่ยนแปลง) */
.custom-pagination .page-item.active .page-link {
  background-color: #2ba9a5 !important;
  border-color: #2ba9a5 !important;
  color: #ffffff;
}

.custom-pagination .page-item .page-link {
  color: #414141;
}

.custom-pagination .page-item:not(.active) .page-link:hover {
  background-color: #f0f0f0;
}
.circle-action-btn {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid #321fdb; /* CoreUI primary */
  background: transparent;
  color: #321fdb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.circle-success-btn{
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid #37d45e; /* CoreUI primary */
  background: transparent;
  color: #37d45e;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.circle-success-btn:hover {
  background-color: #37d45e;
  color: #ffffff;
}

.circle-action-btn:hover {
  background-color: #321fdb;
  color: #ffffff;
}

.circle-cancel-btn {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid #e55353; /* CoreUI danger color */
  background: transparent;
  color: #e55353;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.circle-cancel-btn:hover {
  background-color: #e55353;
  color: #ffffff;
}


.circle-action-btn i {
  font-size: 16px;
}

.status-circle {
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.status-legend {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.status-legend .status-circle {
  width: 14px;
  height: 14px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #414141;
}
</style>

<script>
import { mapGetters } from "vuex";
import Swal from 'sweetalert2';

export default {
  name: "Ureportable",
  data() {
    return {
      ticketsData: [],
    };
  },
  computed: {
    ...mapGetters("auth", ["profile"]),
    tableFields() {
      void this.$store.state.locale.lang
      return [
        { key: "ticketNumber", label: this.$t('table.user.col.ticketNo'), _style: "width:15%;" },
        { key: "reported_datetime", label: this.$t('table.user.col.reportedAt'), _style: "width:20%;" },
        { key: "issue_user", label: this.$t('table.user.col.detail'), _style: "width:40%;" },
        {
          key: "status",
          label: this.$t('table.user.col.status'),
          _style: "width:15%; text-align:center;",
          _classes: "text-center",
        },
        { key: "show_details", label: "", _style: "width:10%;" },
      ]
    },
  },
  mounted() {
    this.loadTickets();
  },
  methods: {
    async loadTickets() {
      try {
        const userId = this.profile?._id;
        if (!userId) {
          console.error("User ID not found");
          return;
        }

        const response = await fetch(
          `${process.env.VUE_APP_APP_URL}/ticket/user/${userId}/active`
        );
        const result = await response.json();

        if (result.success) {
          this.ticketsData = result.data;
        }
      } catch (error) {
        console.error("Failed to load tickets:", error);
      }
    },

    showDetail(item, isEvaluate) {
      this.$emit("show-detail", {
        ...item,
        isEvaluateMode: isEvaluate,
      });
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const suf = this.$store.state.locale.lang === 'th' ? ' น.' : '';
      return `${day}/${month}/${year} ${hours}:${minutes}${suf}`;
    },

    getCategoryName(item) {
      return item.userPart?.category?.departmentName || this.$t('table.user.unknownDept');
    },

    getSubCategoryName(item) {
      const sub = item.userPart?.subCategory;
      if (!sub) return "-";
      if (typeof sub === 'object') {
        return sub.subCategory || sub.name || sub.title || sub.subcategoryName || "-";
      }
      return sub;
    },

    getStatusText(status) {
      const key = `table.user.status.${status}`
      const tr = this.$t(key)
      return tr !== key ? tr : status
    },

    getBadge(status) {
      const badgeMap = {
        pending: "#e55353",
        assigned: "#fd7e14",
        in_progress: "#ffeb3b",
        done: "#2eb85c",
        welldone: "#2eb85c",
        cancelled: "#cdcdcd",
      };
      return badgeMap[status] || "#f8f9fa";
    },

    async cancelTicket(item) {
        const result = await Swal.fire({
            title: this.$t('table.user.swalCancelTitle'),
            html: this.$t('table.user.swalCancelHtml'),
            icon: 'warning',
            input: 'textarea',
            inputPlaceholder: this.$t('table.user.swalPlaceholder'),
            inputAttributes: {
                'aria-label': this.$t('table.user.swalPlaceholder')
            },
            showCancelButton: true,
            confirmButtonColor: '#e55353',
            cancelButtonColor: '#321fdb',
            confirmButtonText: this.$t('table.user.btnConfirmCancel'),
            cancelButtonText: this.$t('table.user.btnBack'),
            inputValidator: (value) => {
                if (!value || value.trim() === '') {
                    return this.$t('table.user.swalReasonRequired');
                }
            }
        });

        if (result.isConfirmed) {
            try {
                const response = await fetch(`${process.env.VUE_APP_APP_URL}/ticket/${item._id}/cancel`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ userId: this.profile._id, cancelReason: result.value })
                });
                
                const data = await response.json();

                if (data.success) {
                    Swal.fire(
                        this.$t('table.user.swalSuccess'),
                        this.$t('table.user.swalSuccessText'),
                        'success'
                    );
                    this.loadTickets(); // Reload list
                } else {
                    Swal.fire('Error', data.message || this.$t('table.user.swalErrCancel'), 'error');
                }
            } catch (error) {
                console.error("Cancel error:", error);
                 Swal.fire('Error', this.$t('table.user.swalErrNetwork'), 'error');
            }
        }
    },
  },
};
</script>